import Card from 'components/Card/TransparentBasic';
import Modal from 'components/Modal';
import {
  ModalCloseIcon,
  StyledClose,
  TransparentModalBody,
  TransparentModalCard,
} from 'components/Modal/Basic';
import React, { FunctionComponent } from 'react';

interface IDocumentModal {
  title: string;
  close: () => void;
}

const DocumentModal: FunctionComponent<IDocumentModal> = ({ title, close, children }) => (
  <Modal isOpen close={close} contentMaxWidth={850}>
    <TransparentModalCard>
      <TransparentModalBody>
        <Card
          title={title}
          rightComponent={
            <ModalCloseIcon>
              <StyledClose onClick={close} />
            </ModalCloseIcon>
          }
        >
          {children}
        </Card>
      </TransparentModalBody>
    </TransparentModalCard>
  </Modal>
);

export default DocumentModal;
